import { render } from "./humanityFiveMuseum.vue?vue&type=template&id=b33ac3c6&scoped=true"
import script from "./humanityFiveMuseum.vue?vue&type=script&lang=js"
export * from "./humanityFiveMuseum.vue?vue&type=script&lang=js"

import "./humanityFiveMuseum.vue?vue&type=style&index=0&id=b33ac3c6&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b33ac3c6"]])

export default __exports__